import type { InjectionKey, Ref } from 'vue';

/**
 * A person's picture by user id, provided once at the app's root (ADR-0048). The app
 * holds where pictures come from; `@therame/ui` only asks. `undefined` while there is
 * none, and the initials stand in.
 */
export type AvatarSource = (userId: string) => Readonly<Ref<string | undefined>>;

export const AvatarSourceKey: InjectionKey<AvatarSource> = Symbol('avatarSource');
